'use strict';

import React from 'react';
import classNames from 'classnames';

/**
 * Provides styles for Modal-overlay, Modal-window, Modal-title, Modal-closeButton,
 * Modal-contentScroll, and Modal-content.
 *
 * The .is-active state class should be added to Modal-overlay to activate the
 * overlay and the modal window.
 *
 * The .modal-active state class is provided for the body to remove scrolling while
 * the modal is active. This class should be removed when the modal is hidden or removed.
 *
 * The default Modal-window dimensions are 60% x 60%. Modifiers are provided to
 * adjust the height and width of the window. e.g.: Modal-window--height8of10, Modal-window--height5of10.
 *
 * Modifiers for all breakpoints (sm: max-width 767px, md: max-width 991px, lg: max-width: 1199px).
 * e.g: Modal-window--heightSm9of10 will render the height at 90% on viewports up to 767px wide.
 *
 * Usage:
 *
 * ```Javascript
 * <Modal />
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} secondary Renders the Modal line color as secondary.
 */
class Modal extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getModalOverlayClassName (isActive) {
    return classNames({
      'Modal-overlay': true,
      'Left-0': true,
      'is-active': isActive
    });
  }

  getModalClassName (height, width) {
    return classNames({
      'Modal-window': true,
      [`Modal-window--height${height}of10`]: true,
      [`Modal-window--widthSm${width}of10`]: true
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { isActive, children, height, width, title, handleCloseOnClick } = this.props;
    return (
      <div className="Modal">
        <div className={this.getModalOverlayClassName(isActive)}>
          <div className={this.getModalClassName(height, width)}>
            <div className="Modal-title">{ title }</div>
            <button className="Modal-closeButton Icon Icon--close" onClick={handleCloseOnClick}></button>
            { children }
          </div>
        </div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Modal component
 */
Modal.propTypes = {
  height: React.PropTypes.number,
  width: React.PropTypes.number
};

Modal.defaultProps = {
  height: 8,
  width: 8
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/modal/modal.jsx